import React from 'react';

const VARIANTS = {
  primary: 'bg-canvas text-forest-deepest hover:bg-white',
  'primary-dark': 'bg-forest text-canvas hover:bg-forest-deep',
  outline: 'border border-canvas/40 text-canvas hover:border-canvas hover:bg-canvas/10',
  'outline-dark': 'border border-forest/30 text-forest-deepest hover:border-forest hover:bg-forest/5',
  ghost: 'text-forest-deepest hover:bg-forest/5',
};

const Button = React.forwardRef(
  ({ variant = 'primary', className = '', loading = false, disabled, children, ...props }, ref) => {
    const variantClass = VARIANTS[variant] || VARIANTS.primary;
    return (
      <button
        ref={ref}
        disabled={disabled || loading}
        className={`inline-flex items-center justify-center gap-2 rounded-none px-10 py-5 text-[11px] font-medium uppercase tracking-[0.18em] transition disabled:cursor-not-allowed disabled:opacity-60 ${variantClass} ${className}`}
        {...props}
      >
        {loading && (
          <span
            className="h-3.5 w-3.5 flex-shrink-0 animate-spin rounded-full border-2 border-current/30 border-t-current"
            aria-hidden="true"
          />
        )}
        {children}
      </button>
    );
  }
);

Button.displayName = 'Button';

export default Button;
